module.exports = __webpack_public_path__ + "static/media/look-back-plan-ahead.0218a998.svg";